import type { IconProps } from '../types/IconProps.ts';
export const SettingsControl: IconProps = {
    name: 'SettingsControl',
    children: [
        `<path d="M10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 0h9M14 17a3 3 0 1 0 6 0 3 3 0 0 0-6 0m0 0H5" />`,
    ]
};